import {getBackendErrorMessage} from "../../shared/utils/httpError";
export {extractListPayload} from "../../shared/utils/payload";

export const getBackendEntityMessage = (error, fallbackMessage) => getBackendErrorMessage(error, fallbackMessage);
